var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalOptions } from '../../../../typings/common';
import useSubmitRefundRequest from '../../../../hooks/useSubmitRefundRequest';
import { StyledDrawerActions } from '../subcomponents';
import { FooterButton } from './subcomponents';
import CBRContext from '../../context';
import { backDataProps, backToAccountManagementFooterDataProps, footerCloseButtonDataProps, submitDataProps } from '../../../../const/analytics';
import { STORE_KEYS } from '../../../../const/store-keys';
import store from '../../../../helpers/store';
var RefundRequestState = function (_a) {
    var handleSetCurrentModal = _a.handleSetCurrentModal;
    var t = useTranslation().t;
    var _b = useContext(CBRContext), removeCBRSessionStorage = _b.removeCBRSessionStorage, setRemoveCBRSessionStorage = _b.setRemoveCBRSessionStorage;
    var submitRefundRequest = useSubmitRefundRequest(handleSetCurrentModal);
    useEffect(function () {
        // ? this avoid the user to submit Refund request successfully after closing drawer or updating address
        return function () {
            if (removeCBRSessionStorage) {
                store.remove(STORE_KEYS.isCbrExecution, 'session');
                store.remove(STORE_KEYS.isProfileEnabled, 'session');
            }
            setRemoveCBRSessionStorage === null || setRemoveCBRSessionStorage === void 0 ? void 0 : setRemoveCBRSessionStorage(true);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(FooterButton, __assign({ buttonType: "ghost", className: "ensightencustomevent", onClick: function () { return handleSetCurrentModal(ModalOptions.default); } }, backDataProps, { children: t('button.back') })), _jsx(FooterButton, __assign({ buttonType: "primary", className: "ensightencustomevent" }, submitDataProps, { onClick: submitRefundRequest }, { children: t('button.submit') }))] }));
};
var SuccessState = function (_a) {
    var handleSetCurrentModal = _a.handleSetCurrentModal, handleCloseModal = _a.handleCloseModal;
    var t = useTranslation().t;
    return (_jsxs(_Fragment, { children: [_jsx(FooterButton, __assign({ buttonType: "ghost", className: "ensightencustomevent", onClick: function () { return handleSetCurrentModal(ModalOptions.default); } }, footerCloseButtonDataProps, { children: t('button.close') })), _jsx(FooterButton, __assign({ buttonType: "primary", className: "ensightencustomevent", onClick: handleCloseModal }, backToAccountManagementFooterDataProps, { children: t('button.backToAccountManager') }))] }));
};
var RenderFooter = function (_a) {
    var currentModal = _a.currentModal, handleSetCurrentModal = _a.handleSetCurrentModal, handleCloseModal = _a.handleCloseModal;
    var t = useTranslation().t;
    switch (currentModal) {
        case ModalOptions.default:
        case ModalOptions.refundError:
            return (_jsx(FooterButton, __assign({ buttonType: currentModal === ModalOptions.default ? 'ghost' : 'primary', className: "ensightencustomevent" }, footerCloseButtonDataProps, { onClick: handleCloseModal }, { children: t('button.close') })));
        case ModalOptions.refundRequest:
            return (_jsx(RefundRequestState, { handleSetCurrentModal: handleSetCurrentModal }));
        case ModalOptions.inProgress:
            return (_jsx(FooterButton, __assign({ buttonType: "primary", className: "ensightencustomevent", onClick: handleCloseModal }, backToAccountManagementFooterDataProps, { children: t('button.backToAccountManager') })));
        case ModalOptions.success:
            return (_jsx(SuccessState, { handleSetCurrentModal: handleSetCurrentModal, handleCloseModal: handleCloseModal }));
        default:
            return null;
    }
};
export var DrawerFooter = function (_a) {
    var handleClose = _a.handleClose, currentDrawer = _a.currentDrawer, setCurrentDrawer = _a.setCurrentDrawer;
    var isLoading = useContext(CBRContext).isLoading;
    // When the drawer is loading, we don't want to show the footer.
    if (isLoading) {
        return null;
    }
    return (_jsx(StyledDrawerActions, __assign({ justifyContent: "end", alignItems: "center" }, { children: _jsx(RenderFooter, { currentModal: currentDrawer, handleSetCurrentModal: setCurrentDrawer, handleCloseModal: handleClose }) })));
};
